import { useEffect, useRef } from 'react';
import { useUser } from '@clerk/nextjs';
import { api } from '~/trpc/react';

export const useProfileUpdateListener = () => {
  const { isLoaded, user } = useUser();
  const previousUserRef = useRef<{ firstName: string; lastName: string; email: string } | null>(null);
  const updateUserInLocations = api.locations.updateUserInLocations.useMutation();

  useEffect(() => {
    if (isLoaded && user) {
      const currentUser = {
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        email: user.emailAddresses[0]?.emailAddress || '',
      };

      const previousUser = previousUserRef.current;
      previousUserRef.current = currentUser;

      // Check if name has changed and we have previous data
      if (previousUser && 
          (previousUser.firstName !== currentUser.firstName || 
           previousUser.lastName !== currentUser.lastName) &&
          currentUser.firstName && 
          currentUser.lastName && 
          currentUser.email) {
        
        console.log('Profile name updated, updating locations...');
        
        // Call the update function
        updateUserInLocations.mutate({
          userId: user.id,
          firstName: currentUser.firstName,
          lastName: currentUser.lastName,
          email: currentUser.email,
        });
      }
    }
  }, [isLoaded, user, updateUserInLocations]);
};
